/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { ISplashPageProps } from './splash-page.props.autogenerated';

export interface ISplashPageViewProps extends ISplashPageProps<any> {
    countryMappingJson: any;
}

/**
 *
 * SplashPage component
 * @extends {React.PureComponent<ISplashPageProps>}
 */
class SplashPage extends React.PureComponent<ISplashPageProps<any>> {
    public render(): JSX.Element | null {
        const viewProps = {
            ...this.props,
            countryMappingJson: this.props.config.countryMapping ? JSON.parse(this.props.config.countryMapping) : {}
        };

        return this.props.renderView(viewProps);
    }
}

export default SplashPage;
